import { render } from "./Environmental Management Policy.vue?vue&type=template&id=daaf370e&scoped=true"
const script = {}

import "./Environmental Management Policy.vue?vue&type=style&index=0&id=daaf370e&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-daaf370e"]])

export default __exports__